export default __webpack_public_path__ + "static/media/img_12.e92bf37d.jpg";